export default __webpack_public_path__ + "static/media/image41.e2fcc7ec.png";